module.exports = __webpack_public_path__ + "img/logo.37a6e062.svg";